import { render, staticRenderFns } from "./StatusesSettings.vue?vue&type=template&id=19fec59a&scoped=true&"
import script from "./StatusesSettings.vue?vue&type=script&lang=ts&"
export * from "./StatusesSettings.vue?vue&type=script&lang=ts&"
import style0 from "./StatusesSettings.vue?vue&type=style&index=0&id=19fec59a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fec59a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VForm,VIcon,VRow})
